import styled from 'styled-components'

interface IStatusCardLegacyRightStyledProps {}

export const StatusCardLegacyRightStyled = styled.div<IStatusCardLegacyRightStyledProps>`
  font-size: ${(props) => props.theme.typography.pxToRem(16)};

  grid-area: right;
  padding: 0 0.5em;
`
